import { useMemo } from 'react';
import { useForm } from 'react-final-form';
import { DropdownOption, TravellerFields, TravellerFormType } from '../../types';
import { LocationSuggestionFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { DirectionField } from './types';

export const useDirections = (cities?: LocationSuggestionFragment[]) => {
	const { t } = useTranslation('Traveller');

	const form = useForm<TravellerFormType>();
	const { departure, arrival } = form.getState()?.values;

	const options = useMemo(() => {
		return cities?.map(city => ({ label: city.name, value: city.iata })) || [];
	}, [cities]);

	const fields = useMemo<DirectionField[]>(
		() => [
			{
				queryFieldName: TravellerFields.DepartureQuery,
				arrayFieldName: TravellerFields.Departure,
				selectedOptions: departure,
				label: t('Departure cities'),
				icon: 'Flight/Takeoff',
				selectedAll: departure?.length === cities?.length
			},
			{
				queryFieldName: TravellerFields.ArrivalQuery,
				arrayFieldName: TravellerFields.Arrival,
				selectedOptions: arrival,
				label: t('Arrival cities'),
				icon: 'Flight/Land',
				selectedAll: arrival?.length === cities?.length
			}
		],
		[departure, arrival, cities, t]
	);

	const filterOptions = (
		options: DropdownOption[],
		value: string,
		selectedOptions: DropdownOption[]
	): DropdownOption[] =>
		options
			/** Поиск по опциям */
			?.filter(option => option.label?.toLowerCase()?.includes(value?.toLowerCase()))
			/** Скрываем уже выбранные города */
			?.filter(option => !selectedOptions?.find(selected => selected.value === option.value));

	const addOption = (field: TravellerFields, value: DropdownOption) => {
		form.mutators.directionsMutator(field, value, 'add');
	};

	const deleteOption = (field: TravellerFields, value: DropdownOption) => {
		form.mutators.directionsMutator(field, value, 'delete');
	};

	return {
		fields,
		options,
		addOption,
		deleteOption,
		filterOptions
	};
};
